import { z } from "zod";

export const GrowLTVGlobalSettingsDtoSchema = z.object({
  shop: z.string(),
});
export type GrowLTVGlobalSettingsDto = z.infer<
  typeof GrowLTVGlobalSettingsDtoSchema
>;

export type GrowLTVExperienceSettingsType = object;

export const GrowLTvGlobalSettingsDtoSchema = z.object({});
